const firebaseConfig = {
    apiKey: "AIzaSyAG2zF0FZmWoOxiNoMbSAwKXXmgKw6X8t0",
    authDomain: "sei-doc.firebaseapp.com",
    databaseURL: "https://sei-doc.firebaseio.com",
    projectId: "sei-doc",
    storageBucket: "sei-doc.appspot.com",
    messagingSenderId: "485197181540",
    appId: "1:485197181540:web:099d1cb8d9652170"
  };
  
  export default firebaseConfig;

